import React from 'react';
import { Profile } from '@conviva/portal-graphql-schema';
import columns from './columns';
import Table from '@components/common/Table';
import { useTableSort } from '@components/common/Table/hooks';

const defaultSort = { key: 'name', order: 'asc' };
interface IAccountTableProps {
  profiles: Profile[];
}

const AccountTable = ({
  profiles,
}: IAccountTableProps) => {

  const { sortBy, onColumnSort, sortedData } = useTableSort({ data: profiles, defaultSort });

  return (
    <Table
      data={sortedData}
      columns={columns}
      fixed
      onColumnSort={onColumnSort}
      sortBy={sortBy}
    />
  );
};

export default AccountTable;
